import { render } from "./pageAchieve.vue?vue&type=template&id=61e4155e&scoped=true"
import script from "./pageAchieve.vue?vue&type=script&lang=js"
export * from "./pageAchieve.vue?vue&type=script&lang=js"

import "./pageAchieve.vue?vue&type=style&index=0&id=61e4155e&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e4155e"]])

export default __exports__